import React, { useState, useEffect, useCallback } from 'react'; 
import axios from 'axios'; 
import {  
    Form,  
    Steps,  
    Button,  
    message,  
    Radio,  
    Modal,  
    Typography,  
    Card,  
    Divider,  
    Space,  
    Input,  
    Alert,  
    Popover
} from 'antd';  
import { useNavigate } from 'react-router-dom';  
import {  
    createUser,  
    loginUser,  
    verifyOtp,  
} from '../../api/user';  
import {  
    createContestant,  
    searchContestants,  
} from '../../api/contestant';  
import ContestantForm from '../../components/frontendForm/contestantForm';  
import EventSelector from '../../components/frontendForm/eventSelector';  
import GroupEventsPage from '../../components/frontendForm/groupEventsPage';  
import {  
    createApplication,  
    getApplicationsByContestant,  
    getApplicationsByGroup,  
    deleteApplication,  
} from '../../api/application';  
import { getInvoicesByContestant } from '../../api/invoice';  
import { useSettings } from '../../contexts/settingsContext';  
import { loadState, saveState } from '../../stores/store';  
import dayjs from 'dayjs';  
import EventSummary from '../../components/frontendForm/eventSummary';  
import {  
    CheckCircleOutlined,  
    LeftOutlined,  
    RightOutlined,  
} from '@ant-design/icons';  
import PhotoUpload from '../../components/frontendForm/photoUpload';
  
import { fetchProvinces } from '../../api/competition';
  
const { Title, Text, Link } = Typography;  
const { Step } = Steps;  
  
const FrontendForm = () => {  
    const [current, setCurrent] = useState(0);  
    const [contestant, setContestant] = useState(null);  
    const [selectedEvents, setSelectedEvents] = useState([]);  
    const [participateInGroupEvents, setParticipateInGroupEvents] = useState(null);  
    const [groupEventChoice, setGroupEventChoice] = useState(null);  
    const [isUserCreated, setIsUserCreated] = useState(false);  
    const [contestants, setContestants] = useState([]);  
    const [createdGroups, setCreatedGroups] = useState([]);  
    const [joinedGroups, setJoinedGroups] = useState([]);  
    const [applications, setApplications] = useState([]);  
    const [groupApplications, setGroupApplications] = useState([]);  
    const [selectedGroupEvents, setSelectedGroupEvents] = useState([]);  
    const [selectedGroupForEvents, setSelectedGroupForEvents] = useState(null);  
    const [form] = Form.useForm();  
    const [submitting, setSubmitting] = useState(false);  
    const [verifying, setVerifying] = useState(false);  
    const [verifyError, setVerifyError] = useState(null);  
    const navigate = useNavigate();  
    const [pendingUser, setPendingUser] = useState(null);  
    const [formValues, setFormValues] = useState(null);  
    const { state: settings } = useSettings();  
    const [otp, setOtp] = useState('');  
    const [invoice, setInvoice] = useState(null);  
    const [isPhotoUploaded, setIsPhotoUploaded] = useState(false);
    const state = loadState();  
  
    const [activeProvinces, setActiveProvinces] = useState([]); 
  
    const competitionId = settings.selectedCompetition?._id || null;  
  
    const fetchActiveProvinces = useCallback(async () => {  
        if (!competitionId) {  
            return;  
        }  
        try {  
            const provinces = await fetchProvinces(competitionId);  
            const activeProvinces = provinces.filter((province) => province.active);  
            setActiveProvinces(activeProvinces);  
        } catch (error) {  
            console.error('Error fetching provinces:', error);  
        }  
    }, [competitionId]);  
  
    useEffect(() => {  
        fetchActiveProvinces();  
    }, [fetchActiveProvinces]);  

    useEffect(() => {  
        const checkLoggedInUserAndContestant = async () => {  
            if (state) {  
                setIsUserCreated(true);  
                try {  
                    const contestantResponse = await searchContestants();  
                    const contestantsArray = contestantResponse && contestantResponse.data ? contestantResponse.data : contestantResponse;  
                    if (Array.isArray(contestantsArray) && contestantsArray.length > 0) {  
                        setContestant(contestantsArray[0]);  
                        setContestants(contestantsArray);  
                        setCurrent(1); 
                    } else {  
                        setCurrent(0);  
                    }  
                } catch (error) {  
                    console.error('Error fetching contestant data:', error);  
                }  
            }  
        };  
        checkLoggedInUserAndContestant();  
    }, []); 
  
    useEffect(() => {  
        const checkLoggedInUserAndContestant = async () => {  
            if (state) {  
                setIsUserCreated(true);  
                try {  
                    const contestantResponse = await searchContestants();  
                    const contestantsArray = contestantResponse && contestantResponse.data ? contestantResponse.data : contestantResponse;  
                    if (Array.isArray(contestantsArray) && contestantsArray.length > 0) {  
                        setContestant(contestantsArray[0]);  
                        setContestants(contestantsArray);  
                        setCurrent(1); 
                    } else {  
                        setCurrent(0);  
                    }  
                } catch (error) {  
                    console.error('Error fetching contestant data:', error);  
                }  
            }  
        };  
        checkLoggedInUserAndContestant();  
    }, []);  
  
    useEffect(() => {  
        if (current === 4) {  
            fetchGroupApplications();  
        }  
    }, [current]);  
  
    const fetchAndSetApplications = async (contestantId) => {  
        try {  
            const applications = await getApplicationsByContestant(contestantId);  
            const eventIds = applications.map((app) => app.event);  
            setSelectedEvents(eventIds);  
        } catch (error) {  
            console.error('Error fetching and setting applications:', error);  
            message.error('There was an error fetching applications.');  
        }  
    };  

    const handlePhotoUploaded = (uploaded) => {  
        setIsPhotoUploaded(uploaded);  
    };  
  
    useEffect(() => {  
        if (contestant) {  
            fetchAndSetApplications(contestant._id);  
        }  
    }, [contestant]);  

    // If contestant already has a saved profile photo in DB, mark photo as uploaded
    useEffect(() => {
        if (!contestant) return;
        const hasPhoto = Boolean(contestant.profilePhotoUrl || contestant.profilePhoto || contestant.profile_photo);
        if (hasPhoto) setIsPhotoUploaded(true);
    }, [contestant]);
  
    const fetchGroupApplications = async () => {  
        try {  
            const allGroupApps = await Promise.all(  
                createdGroups.map((group) => getApplicationsByGroup(group._id))  
            );  
            const groupApps = allGroupApps.flat();  
            setGroupApplications(groupApps);  
        } catch (error) {  
            console.error('Error fetching group applications:', error);  
            message.error('There was an error fetching group applications.');  
        }  
    };  
  
    const handleFormSubmit = async (values) => {    
        try {    
            if (settings.selectedRound !== 1) {    
                throw new Error(    
                    'The selected round is not 1, form submission is not allowed.'    
                );    
            }    
    
            if (values.age < settings.minimumAge) {    
                throw new Error(    
                    `The minimum age for this competition is ${settings.minimumAge}`    
                );    
            }   
              
            setSubmitting(true);    
      
            if (!isUserCreated) {    
                const userData = {    
                    first_name: values.first_name,    
                    last_name: values.last_name,    
                    cell_number: values.cell_number,    
                    work_number: values.work_number,    
                    email: values.email,    
                    password: values.password,    
                    role: 'contestant',    
                    verified: true,
                    province: values.audition_province,
                };    
                const userResponse = await createUser(userData);    
                
                const formattedValues = {  
                    first_name: values.first_name,  
                    last_name: values.last_name,  
                    contestant_number: values.contestant_number || undefined,
                    address: {  
                        street_1: values['address.street_1'],  
                        street_2: values['address.street_2'],  
                        city: values['address.city'],  
                        country: values['address.country'],  
                        province: values['address.province'],  
                        postal_code: values['address.postal_code'],  
                    },  
                    gender: values.gender,  
                    id_number: values.id_number || '0',  
                    date_of_birth: values.date_of_birth
                        ? dayjs(values.date_of_birth).format('YYYY-MM-DD')
                        : null,  
                    passport_number: values.passport_number || '0',  
                    age: values.age,  
                    cell_number: values.cell_number,  
                    work_number: values.work_number,  
                    email: values.email,  
                    ice_contact_name: values.ice_contact_name,  
                    relationship_to_ice: values.relationship_to_ice,  
                    ice_contact_email: values.ice_contact_email,  
                    allergies: values.allergies || false,  
                    allergies_specification: values.allergies_specification,  
                    password: values.password,  
                    confirm_password: values.confirm_password,  
                    created_by: userResponse.user._id,  
                    province: values.audition_province,
                };
    
                const loginResponse = await loginUser(userData.email, userData.password, values.audition_province);    
                saveState(loginResponse);
    
                const contestantResponse = await createContestant(formattedValues);  
                setContestant(contestantResponse.contestant);  
                const fetchedContestants = await searchContestants();  
                setContestants(fetchedContestants);  
                setIsUserCreated(true);  
                setCurrent((prevCurrent) => prevCurrent + 1);  
            } else {    
                setCurrent((prevCurrent) => prevCurrent + 1);    
            }    
            setSubmitting(false);    
        } catch (error) {    
            setSubmitting(false);    
            console.error('Error during form submission:', error);    
            message.error(    
                `There was an error processing your form: ${error.message}`    
            );    
        }    
    };

    const handleLogout = async () => {
        try {
            axios.defaults.headers.common["Authorization"] = "";
            saveState(null);
            navigate("/", { replace: true });
        } catch (error) {
            console.error("Logout error:", error);
        }
    };

    const soloContent = (  
        <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>  
            <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>  
                Entry fee for SOLO ENTRIES is calculated at <strong>R680-00 (incl VAT)</strong>. This ENTRY FEE allows you to enter a minimum of <strong>4 SOLO items</strong>. The items entered can be from <em>ANY EVENT</em> (acting, dance, instrumentals, modelling, variety acts, and vocals) and <em>ANY STYLE</em> (open, hip hop, contemporary, gospel, dramatical, etc.).  
            </Text>  
      
            <Text strong style={{ marginTop: '10px', fontSize: '18px' }}>  
                NOTE:  
            </Text>  
      
            <Text style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '10px' }}>  
                You MUST qualify for at least <strong>2 STYLES</strong> (open, hip hop, contemporary, gospel, dramatical, etc.) in your choice of EVENT (acting, dance, instrumentals, modelling, variety acts, and vocals) to qualify for the South Africa Championships of Performing Arts 2026.  
            </Text>  
      
            <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>  
                <li>Make sure that you select the correct EVENTS and STYLES.</li>  
                <li>The R680-00 (incl VAT) ENTRY FEE allows you to enter a minimum of 4 STYLES from ANY EVENT.</li>  
                <li>You are allowed to enter for more than 2 STYLES (open, hip hop, contemporary, gospel, dramatical, etc.) per EVENT (acting, dance, instrumentals, modelling, variety acts, and vocals).</li>  
                <li>Each ADDITIONAL STYLE (over and above the 4 minimum) will be <strong>R170-00 (incl VAT)</strong> per style EXTRA.</li>  
            </ul>  
        </div>  
    );  
  
    const next = async () => {  
        if (current === 0) {  
            form.validateFields()  
                .then((values) => {  
                    handleFormSubmit(values);  
                })  
                .catch((info) => {  
                });  
        } else if (current === 1) {  
            if (!isPhotoUploaded) {  
                message.error('Please upload a profile photo before proceeding.');  
                return;  
            }  
            setCurrent((prevCurrent) => Math.min(prevCurrent + 1, steps.length - 1));  
        } else if (current === 2) {  
             // Only allow progressing when selectedEvents length is 0 (optional), or at least 4  
            if (!(selectedEvents.length === 0 || selectedEvents.length >= 4)) {  
                message.error('You must apply for a minimum of 4 events (or leave all blank).');  
                return;  
            }  
            setSubmitting(true);
            try {  
                const existingApplications = await getApplicationsByContestant(contestant._id);  
                const invoiceId = await getInvoicesByContestant(contestant._id, 1);  
                setInvoice(invoiceId);  
                const eventsToApply = selectedEvents.filter((event) => {  
                    return !existingApplications.some(  
                        (app) => app.event._id === event._id && app.round === settings.selectedRound  
                    );  
                });  
                const eventsToRemove = existingApplications.filter((app) => {  
                    return !selectedEvents.some((event) => event._id === app.event._id);  
                });  
                const applicationPromises = eventsToApply.map((event) => {  
                    const applicationData = {  
                        event: event._id,  
                        contestant: contestant._id,  
                        created_by: contestant.created_by,  
                        province: state.user.activeProvince,  
                        instrument: event.instrument || undefined,  
                    };  
                    return createApplication(applicationData);  
                });  
                await Promise.all(applicationPromises);  
                const deletePromises = eventsToRemove.map((app) => {  
                    return deleteApplication(app._id);  
                });  
                await Promise.all(deletePromises);  
                message.success('Applications updated successfully!');  
                const updatedApplications = await getApplicationsByContestant(contestant._id);  
                setApplications(updatedApplications);  
                setCurrent((prevCurrent) =>  
                    Math.min(prevCurrent + 1, steps.length - 1)  
                );  
                setSubmitting(false);  
            } catch (error) {  
                setSubmitting(false);  
                console.error('Error updating applications:', error);  
                message.error('There was an error updating applications.');  
            }  
        } else if (current === 3) {  
            setCurrent((prevCurrent) => Math.min(prevCurrent + 1, steps.length - 1));  
        } else if (current === 4) {  
            setCurrent((prevCurrent) => Math.min(prevCurrent + 1, steps.length - 1));  
        } else if (current === 5) {  
            navigate('/events', { replace: true });  
        } else {  
            setCurrent((prevCurrent) => Math.min(prevCurrent + 1, steps.length - 1));  
        }  
    }; 
  
    const prev = () => {  
        setCurrent((prevCurrent) => Math.max(prevCurrent - 1, 1));  
    };  
  
    const handleSelectEvent = (event) => {  
        const eventExists = selectedEvents.some((e) => e._id === event._id);  
        if (eventExists) {  
            setSelectedEvents(selectedEvents.filter((e) => e._id !== event._id));  
        } else {  
            setSelectedEvents([...selectedEvents, event]);  
        }  
    };  
  
    const handleGroupEventChoice = (e) => {  
        setGroupEventChoice(e.target.value);  
        if (e.target.value === 'yes') {  
            setParticipateInGroupEvents(true);  
        } else {  
            setCurrent(4);  
        }  
    };  
  
    const handleCreateGroup = async (groupData) => {  
        setCreatedGroups((prevGroups) => [...prevGroups, groupData]);  
    };  
  
    const handleJoinGroup = (groupData) => {  
        setJoinedGroups([...joinedGroups, groupData]);  
    };  
  
    const handleOtpChange = (text) => {
        const ask = text
        setOtp(ask);
    };
  
    const sharedProps = {  
        handleOtpChange,  
    };  

  
    const steps = [  
        {  
          title: 'Contestant Info',  
          content: (  
            <ContestantForm  
              onNext={handleFormSubmit}  
              submitting={submitting}  
              form={form}
              provinces={activeProvinces}  
            />  
          ),  
        },  
        {  
            title: 'Profile Upload',  
            content: (  
              <PhotoUpload  
                onNext={next}  
                submitting={submitting}  
                onPhotoUploaded={handlePhotoUploaded}  
                contestant={contestant}            // Pass contestant object!  
                setContestant={setContestant}      // So PhotoUpload can update photo url in contestant state  
              />  
            ),  
          },
        {  
          title: 'Event Selection',  
          content: (  
            <EventSelector  
              contestant={contestant}  
              selectedEvents={selectedEvents}  
              onSelectEvent={handleSelectEvent}  
            />  
          ),  
        },  
        {  
          title: 'Event Summary',  
          content: (  
            <EventSummary  
              applications={applications}  
              contestant={contestant}  
            />  
          ),  
        },  
      ];  

    function formatDate(dateString) {  
    const date = new Date(dateString);  
    return date.toISOString().split('T')[0];
}  
  
    return (  
        <div className="frontend-form">  
            {settings.imagePath && (  
                <img  
                    src={settings.imagePath}  
                    alt="logo"  
                    className="frontend-form-logo"  
                />  
            )}  
            <div  
                className="frontend-form-graphic"  
                style={{  
                    backgroundImage: 'url("/images/SACOPAPortalBackground.svg")',  
                }}  
            ></div>  
            <Card className="frontend-form-container">  
                <Steps  
                    size="small"  
                    current={current}  
                    className="steps-container"  
                >  
                    {steps.map((item) => (  
                        <Step key={item.title} title={item.title} />  
                    ))}  
                </Steps>  
                {current > 0 && (  
                    <div style={{ textAlign: 'right', marginTop: '16px' }}>  
                        <Button type="default" onClick={handleLogout}>  
                            Logout  
                        </Button>  
                    </div>  
                )} 
            {current === 2 && (
                <>  
                    <Title level={3}>{steps[current].title}</Title>  
                    <Text type="secondary">  
                        Please fill out the form below to apply for the competition.  
                    </Text>  
                    <Popover   
                        content={soloContent}   
                        title="Entry Fee Information"   
                        trigger="click"   
                        placement="right"
                        overlayStyle={{ width: '500px' }}
                    >  
                        <Button type="link">View Entry Fee Info</Button>  
                    </Popover>
                </>  
            )}
                <Divider />  
                {current !== 5 || current !== 2 || current !== 3 && (  
                    <>  
                        <Title level={3}>{steps[current].title}</Title>  
                        <Text type="secondary">  
                            Please fill out the form below to apply for the  
                            competition.  
                        </Text>  
                    </>  
                )}  
                <div className="steps-content">  
                    {steps[current] && steps[current].content}  
                </div>  
                <div className="steps-action">  
                    {current > 1 && current !== 6 && (  
                        <Button  
                            iconPosition="start"  
                            icon={<LeftOutlined />}  
                            onClick={() => prev()}  
                        >  
                            Previous  
                        </Button>  
                    )}  
                    {current < steps.length - 1 && current !== 0 && (  
                        <Button  
                            type="primary"  
                            loading={submitting}  
                            iconPosition="end"  
                            icon={<RightOutlined />}  
                            onClick={() => next()}  
                        >  
                            Next  
                        </Button>  
                    )}  
                </div>  
            </Card>  
        </div>  
    );  
};  
export default FrontendForm;  